/* eslint-disable import/first,no-func-assign */
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgOfficeBranch = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64",
  "aria-hidden": !props['aria-label'],
  focusable: "false"
}), /*#__PURE__*/React.createElement("path", {
  d: "M56 20H42V8l-2-2H8L6 8v46l2 2h48l2-2V22l-2-2ZM10 10h28v42H28v-6h-8v6H10V10Zm44 42H42V24h12v28Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18 14h-4v4h4v-4Zm8 0h-4v4h4v-4Zm-8 8h-4v4h4v-4Zm8 0h-4v4h4v-4Zm-8 8h-4v4h4v-4Zm8 0h-4v4h4v-4Zm8-16h-4v4h4v-4Zm0 8h-4v4h4v-4Zm0 8h-4v4h4v-4Zm-16 8h-4v4h4v-4Zm8 0h-4v4h4v-4Zm8 0h-4v4h4v-4Zm16-10h-4v4h4v-4Zm0 8h-4v4h4v-4Zm0 8h-4v4h4v-4Z"
}));

export default SvgOfficeBranch;